jQuery(function($) {
  $('.carousel').slick({
    arrows: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 770,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });
});
